abstract class PrivateCommand {

    public abstract execute(option?:string, callback?:Function) : void;

}

export {PrivateCommand}
